// A parcel link has to name ONE parcel (#1281, #1292).
//
// `parcels` is UNIQUE on (state, county, parcel_id) — the bare APN is not
// an identity. County assessors mint the same string independently, so
// "00-0000-0187" is a Salt Lake parcel AND a Wasatch parcel, and the
// backend resolves a bare APN to the LOWEST row id. Measured on
// production 2026-11-02: 97,762 colliding APNs, and 115,183 parcels are
// not the lowest-id row for their APN — every one of them renders a
// DIFFERENT parcel than the list row that linked to it.
//
// A link that carries only the APN is therefore a coin flip. This helper
// carries the row's own state and county as query parameters; the parcel
// detail page forwards them to `GET /parcels/{id}?state=..&county=..`,
// which resolves the exact parcel.
//
// Both parameters are optional. A row with no state still gets a working
// link, and the detail page renders a disambiguation picker when the
// response carries `ambiguous` — so an ambiguous link is visible rather
// than silently wrong.
//
// `suffix` appends a sub-route ("/research", "/print") AFTER the path
// and BEFORE the query string, so the query parameters survive.

export function parcelPath(parcelId, { state, county, suffix = '' } = {}) {
  const base = `/parcel/${encodeURIComponent(parcelId)}${suffix}`;
  const params = [];
  if (state) params.push(`state=${encodeURIComponent(state)}`);
  if (county) params.push(`county=${encodeURIComponent(county)}`);
  if (!params.length) return base;
  return `${base}?${params.join('&')}`;
}

export default parcelPath;
